import {useMutation} from "@tanstack/react-query";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {PromoTokensApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useOpenPromoTokenLink() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async (distributedRewardId: string): Promise<string> => {
            const response = await new PromoTokensApi(getConfig(fullToken)).createPromoTokensIdOpenLink({id: distributedRewardId});
            return response.redirectPath;
        },
    });
}
